import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { RootState } from '../store/store';
import type { MilestoneMap1 } from '@mm-shared/types/MilestoneMap1';
import { selectMapByShortId } from '../store/selectors';

/**
 * Custom hook that combines useParams + useSelector for URL-aware current map selection
 * @returns The current milestone map based on the URL mapShortId parameter, or null if not found
 */
export function useCurrentMap(): MilestoneMap1 | null {
  const { mapShortId } = useParams();
  return useSelector((state: RootState) =>
    mapShortId ? selectMapByShortId(state, mapShortId) : null,
  );
}
